<script>
import BasketService from '../services/api/BasketService';

export default {
    name: "NoLoginBasket",
    data() {
      return {
      }
    },
    computed: {
        noLoginBasketCount() {
            return this.noLoginBasketItems.length;
        },
        noLoginBasketItems() {
            return this.$store.getters.noLoginBasket;
        }

    },
    methods: {
        setNoLoginBasket(localBasket) {
            localStorage.setItem('NoLoginBasket', JSON.stringify(localBasket));
            this.$store.commit('setNoLoginBasket', localBasket);
        },
        addToNoLoginBasket(products) {
            const localBasket = this.noLoginBasketItems;
            products.forEach(product=>{
                const idx = this.noLoginBasketItems.findIndex(item => item.id === product.id);
                if (idx < 0){
                    localBasket.push(product)
                } else {
                    localBasket[idx].quantity = product.quantity;
                }
            })
            return this.setNoLoginBasket(localBasket)
        },
        updateNoLoginBasket(product) {
            const localBasket = this.noLoginBasketItems.map( item => {
                return (item.id == product.id) ? product : item;
            });

            this.setNoLoginBasket(localBasket);
        },
        deleteProductFromNoLoginBasket(id) {
            const localBasket = this.noLoginBasketItems.filter(item=>{
                return item.id != id;
            })
            this.setNoLoginBasket(localBasket)
        },
        getNoLoginProductQuantity(id) {
            const product =  this.noLoginBasketItems.find(item => item.id == id);

            return (product !== undefined) ? product.quantity : 1 ;
        },
        mergeNoLoginBasketWithBasket() {
            const products = this.noLoginBasketItems.map(item => {
                return {
                    id: item.id,
                    quantity: item.quantity
                }
            });
            BasketService.updateList(products)
                .then(res => {
                    this.$store.commit('setBasket', res.data);
                    this.setNoLoginBasket([]);
                })
                .catch(err => {
                    console.log(err)
                });
        },
        isInNoLoginBasket(id) {
            return (this.noLoginBasketItems.findIndex(item => item.id === id) >= 0);
        }
    }
}
</script>

